/**
 * Canonical gate for the Pool Amendment module (Large Sets PRD §4.3, owner
 * decision D3 — default OFF). Controls whether the Arrival Bay offers
 * "Amend into pool"; the server enforces the same opt-in in
 * amend_locked_pool (migration 723), so the gate is a courtesy, not the wall.
 */

import { useModuleGate } from '../../../lib/moduleGate';

export function usePoolAmendmentEnabled(): boolean {
  return useModuleGate('pool_amendment');
}
